<template>
  <div>

    <!-- MOBILE TOOLBAR -->
    <div v-if="$vuetify.breakpoint.xs" :class="['c-flex-c mobile-top-bar']">
      <div class="c-flex-r align-center">
        <v-btn
        icon
        @click="goBack">
          <v-icon color="color1">arrow_back</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <span class="text-ellipsed">
          {{ definition.name }}
        </span>
        <v-spacer></v-spacer>

        <!-- save button -->
        <transition mode="out-in" name="scale-transition">
          <v-btn
          v-if="isDirty"
          key="1"
          icon
          flat
          :loading="saving"
          @click="validateForm">
            <v-icon color="color1" >check</v-icon>
          </v-btn>

          <v-btn
          v-else
          key="2"
          icon
          flat
          disabled>
            <v-icon>check</v-icon>
          </v-btn>
        </transition>

      </div>
    </div>

    <!-- PC TOOLBAR -->
    <div v-if="!$vuetify.breakpoint.xs" class="pl-4 pr-4 pt-4">
      <v-breadcrumbs class="pl-0">
        <v-breadcrumbs-item to="/dashboard/">
          Home
        </v-breadcrumbs-item>
        <span class="pl-2 pr-2">/</span>
        <v-breadcrumbs-item to="/inventory/inventory-definitions" exact>
          Inventory definitions
        </v-breadcrumbs-item>
        <span class="pl-2 pr-2">/</span>
        <v-breadcrumbs-item :to="`/inventory/inventory-definition/view/${this.id}`" exact>
          {{ definition.name }}
        </v-breadcrumbs-item>
        <span class="pl-2 pr-2">/</span>
        <v-breadcrumbs-item disabled>
          Edit
        </v-breadcrumbs-item>
      </v-breadcrumbs>

      <div class="c-flex-r align-center">
        <v-btn
        icon
        @click="goBack">
          <v-icon color="color1">arrow_back</v-icon>
        </v-btn>
        <div class="title text--text text--lighten-1">
          {{ definition.name }}
        </div>

      </div>
      <div class="c-flex-r align-center">
      <img class="c-align-self-start" src="@/assets/img/illustrations/cream.png" alt="cardboard box" width="80px">
        <!-- save button -->
        <div style="min-height: 36px;" class="ml-2">
          <transition mode="out-in" name="scale-transition">
            <v-btn
            v-if="isDirty"
            key="1"
            color="color1"
            class="white--text ma-0"
            :loading="saving"
            @click="validateForm">
            Save
            </v-btn>
          </transition>
        </div>
      </div>
    </div>


    <!-- MAIN CONTENT -->
    <v-layout column
    :class="[{'pl-4': !$vuetify.breakpoint.xs}]"
    style="flex: 1;position: relative; overflow: auto;">
      <edit-form 
      ref="form"
      :id="id"
      :isDirty.sync="isDirty"></edit-form>
    </v-layout>

    <!-- dialog -->
    <v-dialog v-model="dialogSaved" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Definition updated!!</v-card-title>
        <v-card-text>All changes successfully stored.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" outlined @click="dialogSaved = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import EditDefinitionForm from './components/EditForm'

export default {
  props: ['id'],
  components: {
    'edit-form': EditDefinitionForm
  },
  data () {
    return {
      dialogSaved: false,
      previousPage: '',
      isDirty: false,
      saving: false,
      definition: {}
    }
  },
  computed: {
  },
  methods: {
    goBack () {
      console.log(this.previousPage)
      this.$router.replace(this.previousPage)
    },
    validateForm () {
      var valid = this.$refs.form.validateForm()
      if (valid) {
        console.log('Invalid')
      } else {
        this.updateItem()
      }
    },
    open () {
      this.$refs.form.edit()
    },
    updateItem () {
      this.saving = true
      this.error = ''
      // this is the variable to overwrite lastSaved (missing the id property)
      var dataPreSave = JSON.parse(JSON.stringify(this.$refs.form.formData))
      var data = JSON.parse(JSON.stringify(this.$refs.form.formData))
      data.id = this.id
      data.mass = data.mass || 0 // If null set it to zero so MariaDB doesnt throw an error
      data.volume = data.volume || 0
      data.length = data.length || 0
      this.$axios.patch('inventory-definitions/update/',
        data,
        {headers: {'Content-Type': 'application/json'}})
        .then(
          (response) => {
            console.log('PRESAVE')
            console.log(dataPreSave)
            this.$refs.form.lastSave = JSON.parse(JSON.stringify(dataPreSave))
            this.dialogSaved = true
          })
        .catch(
          (error) => {
            this.error = JSON.stringify(error.response.data.errors)
            this.$root.$errorSnackbar(error)
          })
        .then(() => {
          this.saving = false
        })
        // */
    },
    loadAPI: _.debounce(function (e) {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        this.$axios.get(`inventory-definitions/${this.id}`)
        .then((response) => {
          this.definition = response.data
          resolve(response.data)
        })
        .catch(error => {
          console.log(error)
          this.$root.$errorSnackbar(error)
          reject(error)
        })
        .then(() => {
          this.isLoading = false
        })
      })
    }, 150, {leading: true}),
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.previousPage = from.path === '/loading' ? '/inventory/inventory-definition/view/' + vm.id : from.path
      next()
    })
  },
  created () {
    this.loadAPI()
  }
}
</script>
